import { render, staticRenderFns } from "./DoYouHaveNewService.vue?vue&type=template&id=c703fa10&"
import script from "./DoYouHaveNewService.vue?vue&type=script&lang=js&"
export * from "./DoYouHaveNewService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports